import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Marquee } from '../components/marquee';
import VideoPlayer from '../components/videoPlayer3';
import { useHideMenu } from '../hooks/useHideMenu';
import { UseSweetAlert } from '../hooks/useSweetAlert';
import { SocketContext } from '../context/SocketContext';
import { getUltimos } from '../helpers/getUltimos';
import { serverApi } from '../api';

import sound from "../assets/new-ticket.mp3";
import { SelectElement } from '../components/selectElement';

export const Cola2 = () => {

    const [formData, setFormData] = useState({
        codigoEntidad: '',
        codigoUbicacion: ''
    });

    useHideMenu(true);

    const { socket, conectarSocket } = useContext(SocketContext);

    const [entidadStorage, setEntidadStorage] = useState(
        localStorage.getItem('codigoEntidad') || null
    );
    const [ ubicaciones, setUbicaciones ] = useState([]);

    const [videoList, setVideoList] = useState(
        localStorage.getItem('videos') || ""
    );


    const [tickets, setTickets] = useState([]);
    // const [llamadoVoz, setLlamadoVoz] = useState(0);
    const [minutosUltimo, setMinutosUltimo] = useState(0);

    const handleInputChange = (e) => {
        const newValue = e.target.value;

        // Si cambia el código de entidad, limpiar las sedes anteriores
        if (e.target.id === 'codigoEntidad') {
            setUbicaciones([]);
            setFormData((prev) => ({
                ...prev,
                codigoEntidad: newValue,
                codigoUbicacion: '',
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [e.target.id]: newValue
            }));
        }
    };

    const fetchUbicaciones = useCallback(async (codigo) => {
        if (!codigo || codigo.trim().length < 3) return;

        try {
            const resp = await serverApi.post(
                `/auth/select-ubicacion-pantallas`,
                { codigoEntidad: codigo.trim() }
            );

            if (!resp.data.ubicaciones || resp.data.ubicaciones.length === 0) return;

            const data = resp.data.ubicaciones.map((item) => ({
                value: item.codigoUbicacion,
                label: item.nombreUbicacion
            }));

            setUbicaciones(data);
        } catch (error) {
            console.error("Error al obtener ubicaciones", error);
        }
    }, []);

    // Dispara la búsqueda de sedes automáticamente al montar o al cambiar el código
    useEffect(() => {
        if (formData.codigoEntidad && formData.codigoEntidad.trim().length >= 3) {
            fetchUbicaciones(formData.codigoEntidad.trim());
        }
    }, [formData.codigoEntidad, fetchUbicaciones]);

    const parseVideos = (videosRaw) => {
        try {
            if (!videosRaw) return "";

            const parsed = typeof videosRaw === "string"
                ? JSON.parse(videosRaw)
                : videosRaw;

            return parsed.map(v => v.code).join(',');

        } catch (e) {
            console.error("Error parseando videos:", e);
            return "";
        }
    };


    const ingresar = async() => {

        
        if (formData.codigoUbicacion === "" || formData.codigoEntidad==="") return UseSweetAlert("Atención!", 'Falta información', 'error');
        
        const resp = await serverApi.post(
            `/auth/registro-pantallas`,
            formData
        );
        
        const pantallas = resp.data.pantallas;
        if (!pantallas || pantallas.length === 0) {
            return UseSweetAlert("Atención!", "Revise la información", "error");
        }

        

        const pantalla = pantallas[0];

        const listaVideos = parseVideos(pantalla.videos);


        localStorage.setItem('codigoEntidad', formData.codigoEntidad);
        localStorage.setItem('codigoUbicacion', formData.codigoUbicacion);
        localStorage.setItem('llamadoVoz', pantallas[0].llamadoVoz);
        localStorage.setItem('videos', listaVideos);

        conectarSocket({
            query: {
                codigoEntidad: formData.codigoEntidad,
                ubicacion: formData.codigoUbicacion,
                
            }
        });
        
        setEntidadStorage(formData.codigoEntidad);
        setVideoList(pantallas[0].videos || "");
        
        const tks = await getUltimos();

        setTickets(tks ?? []);
    }

    useEffect(() => {

        const fetchVideos = async () => {

            const codigoEntidad = localStorage.getItem("codigoEntidad");
            const codigoUbicacion = localStorage.getItem("codigoUbicacion");

            if (!entidadStorage) return;

            try {
                const resp = await serverApi.post(
                    `/videos/lista-videos-mostrar`,
                    { codigoEntidad, codigoUbicacion }
                );
                
                // const raw = resp.data.videos?.[0]?.listaVideos;

                // const lista = parseVideos(raw);

                
                const listaVideos =  resp.data.videos.map(v => v.videoCodigo).join(',');
                localStorage.setItem('videos', listaVideos);
                setVideoList(listaVideos);

            } catch (error) {
                console.error(error);
            }
        };

        fetchVideos();

    }, [entidadStorage]);
  
    // --- FUNCIÓN NATIVA PARA SINTETIZAR VOZ ---
    
    const decirTexto = useCallback((text) => {
        const synth = window.speechSynthesis;

        const ejecutarVoz = () => {
            const voices = synth.getVoices();

            const utterThis = new SpeechSynthesisUtterance(text);

            // Español latino
            const vocesLatinas = voices.filter(v =>
                ['es-MX', 'es-CO', 'es-AR', 'es-CL', 'es-PE', 'es-US']
                .includes(v.lang)
            );

            // Intentar voz femenina conocida
            const vozFemenina = vocesLatinas.find(v =>
                /paulina|helena|monica|maria|sofia|female/i.test(v.name)
            );

            // Fallback: primera latina
            const vozSeleccionada =
                vozFemenina ||
                vocesLatinas[0] ||
                voices.find(v => v.lang.startsWith('es')) ||
                voices[0];

          
            utterThis.voice = vozSeleccionada;
            utterThis.lang = vozSeleccionada?.lang || 'es-CO';
            utterThis.rate = 0.8;
            utterThis.pitch = 1;

            synth.cancel(); // evita colas acumuladas
            synth.speak(utterThis);
        };

        if (synth.getVoices().length > 0) {
            ejecutarVoz();
        } else {
            synth.onvoiceschanged = ejecutarVoz;
        }
    }, []);

    
    
    useEffect(() => {
        if (!socket) return;

        // 🔵 EVENTO: LISTADO COMPLETO
        const handleAsignados = (ticketsList) => {
            if (ticketsList.length === 0) {
                return
            }
            const t = ticketsList[0];

            const hoy = new Date();
            const ultimo = new Date(t.llamadoEn);
            const diferencia = (hoy - ultimo) / (1000 * 60);
            setMinutosUltimo(diferencia);

            // setLlamadoVoz(t.llamadoVoz);

            const paciente = t.nombrePaciente?.trim() || 
                `Turno ${t.codigoTipoAtencion} ${t.numeroTicket}`;

            const mensaje = `${paciente}, pase a ${t.moduloClase} ${t.modulo}`;

            if (t.llamadoVoz === 1) decirTexto(mensaje);
            else new Audio(sound).play();
        };

        // 🟡 EVENTO: SOLO UN TICKET
        const handleVolverLlamar = (ticket) => {
            if (!ticket || ticket.length === 0) return;

            const t = ticket[0];
            
            const hoy = new Date();
            const ultimo = new Date(t.llamadoEn);
            const diferencia = (hoy - ultimo) / (1000 * 60);
            setMinutosUltimo(diferencia);
            

            // setLlamadoVoz(t.llamadoVoz);

            const paciente = t.nombrePaciente?.trim() || 
                `Turno ${t.codigoTipoAtencion} ${t.numeroTicket}`;

            const mensaje = `${paciente}, pase a ${t.moduloClase} ${t.modulo}`;

            // ❌ NO setTickets aquí

            if (t.llamadoVoz === 1) decirTexto(mensaje);
            else new Audio(sound).play();
        };

        const handleListar = (tickets) => {
            
            if(tickets.length === 0 ) {
                setTickets([]);
                return;

            }
            const t = tickets[0];

            const hoy = new Date();
            const ultimo = new Date(t.llamadoEn);
            const diferencia = (hoy - ultimo) / (1000 * 60);
            setMinutosUltimo(diferencia);

            setTickets(tickets ?? []);

        }

        socket.on('ticket-asignado', handleAsignados);
        socket.on('volver-llamar', handleVolverLlamar);
        socket.on('ticket-listado-13', handleListar);

        return () => {
            socket.off('ticket-asignado', handleAsignados);
            socket.off('volver-llamar', handleVolverLlamar);
            socket.off('ticket-listado-13', handleListar);

        };

    }, [socket, decirTexto]);

    useEffect(() => {
        const load = async () => {
            const tks = await getUltimos();
            if(!tks) {return};
            if(tks.length === 0 ) return;
            const t = tks[0];

            const hoy = new Date();
            const ultimo = new Date(t.llamadoEn);
            const diferencia = (hoy - ultimo) / (1000 * 60);
            setMinutosUltimo(diferencia);
            setTickets(tks ?? []);
        };
        load();
    }, []);

    

    return (
        <>
            {entidadStorage !== null ? (
                <div className='px-3 vh-100 max-widtth-100'>
                    <div className="row" style={{ padding: "2px" }}>
                        <div className="col-6 list-group">
                            <VideoPlayer videos={videoList} />
                        </div>
                        <div className="col-6 list-group" style={{ fontSize: "12px" }}>
                            <table className="table table-borderless">
                                <thead>
                                    <tr>
                                        <th className="text-center fs-2" width="60%"> Turno </th>
                                        <th className="text-center fs-2" width="40%"> Módulo </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tickets.slice(0, 6).map((ticket, index) => {
                                        const textoModulo = `${ticket.moduloClase} ${ticket.modulo}`;
                                        const esMuyLargo = textoModulo.length > 24;
                                        const esLargo = textoModulo.length > 13;
                                        const fontSizeModulo = esMuyLargo ? 'fs-6' : esLargo ? 'fs-5' : 'fs-4';
                                        
                                        
                                        const color = (index === 0 && minutosUltimo < 0.10) ? "#f58733" : "#0098da";



                                        return (
                                            <tr key={index} className={index === 0 && minutosUltimo < 0.10 ? 'parpadea' : ''}>
                                                <td width="60%">
                                                    <span className="badge rounded-pill p-1" style={{ width: "100%", height: "50px", backgroundColor: color, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        {ticket.nombrePaciente.trim() !== "" 
                                                            ? <span className='fs-5'>{ticket.codigoTipoAtencion}-{ticket.numeroTicket} {ticket.nombrePaciente}</span>
                                                            : <span className='fs-3'>{ticket.codigoTipoAtencion}-{ticket.numeroTicket} {ticket.numeroDocumento}</span>
                                                        }
                                                    </span>
                                                </td>
                                                <td width="40%">
                                                    <span className={`badge rounded-pill p-1 ${fontSizeModulo}`} style={{ width: "100%", height: "50px", backgroundColor: color, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <span style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", lineHeight: "1.1em" }}>
                                                            {textoModulo}
                                                        </span>
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className='col-12' style={{ padding: "0px" }}>
                            <div className="App">
                                <Marquee />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
            <div className="login-container d-flex align-items-center justify-content-center p-3" style={{ minHeight: "100vh", backgroundColor: '#f4f7f6' }}>
                <div className="col-12 col-md-6 col-lg-4">
                    <div className="card shadow-lg border-0 rounded-4 overflow-hidden" style={{ backgroundColor: '#ffffff' }}>
                        <div className="p-4 text-white text-center" style={{ background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)' }}>
                            <div className="d-inline-flex align-items-center justify-content-center mb-2 rounded-circle" style={{ width: 56, height: 56, background: 'rgba(255,255,255,0.15)' }}>
                                <i className="fa-solid fa-[#14b8a6] fa-tv fs-3" style={{ color: '#14b8a6' }}></i>
                            </div>
                            <h4 className="fw-bold m-0" style={{ letterSpacing: '0.5px' }}>Pantalla de Llamado</h4>
                            <p className="mb-0 opacity-75 small">Configuración de Visualización de Turnos</p>
                        </div>

                        <div className="p-4">
                            <div className="mb-3">
                                <label htmlFor="codigoEntidad" className="form-label small fw-bold text-secondary">Código de Entidad / Empresa</label>
                                <div className="input-group">
                                    <span className="input-group-text bg-light border-end-0">
                                        <i className="fa-solid fa-building" style={{ color: '#0d7367' }}></i>
                                    </span>
                                    <input 
                                        type="text" 
                                        className="form-control border-start-0 ps-0 shadow-none" 
                                        id="codigoEntidad" 
                                        placeholder="Ej: femcc-01"
                                        value={formData.codigoEntidad}
                                        onChange={handleInputChange}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>

                            { ubicaciones.length > 0 &&  
                                <div className='mb-4'>
                                    <label htmlFor="codigoUbicacion" className="form-label small fw-bold text-secondary">Sede / Ubicación</label>
                                    <SelectElement
                                        options={ubicaciones}
                                        id={"codigoUbicacion"}
                                        name={"codigoUbicacion"}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        className={"shadow-sm rounded-3"}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }

                            { formData.codigoUbicacion && (
                                <button 
                                    className="btn w-100 py-3 fw-bold text-white shadow-sm rounded-3 transition-all mt-2" 
                                    type="button" 
                                    onClick={ingresar}
                                    style={{ background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)', border: 'none' }}
                                >
                                    INGRESAR A LA PANTALLA →
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            )}
        </>
    );
};

